export const iconFontAwesomeCodingFilter = (
	<i className="fa-solid fa-filter"></i>
);
